/**
 * SoaMark — símbolo «Estados» + lockup de SOA 10 PRO (handoff README §1).
 *
 * Símbolo: contenedor cuadrado, radio 27 %, fichas posicionadas en % del contenedor.
 *   OS (fondo #0B0D10): 4 fichas de 27 % × 27 % (radio 30 %), siempre en este orden:
 *     cian #22D3EE (arriba-izq) · verde #10B981 · violeta #8B5CF6 · ámbar #F59E0B
 *   Debajo de 24 px las fichas pasan a 29 % y se pegan (sin separación) para no empastarse.
 *   No cambiar el orden, no hacer círculos, no usar otros fondos que #0B0D10 o blanco.
 * Portal: ver SoaSymbol variant="portal" (ficha 58×40 + pastilla de acción).
 */
import { cn } from "../lib/utils.js";

const FICHAS_OS = [
  { c: "#22D3EE", x: 0, y: 0 },
  { c: "#10B981", x: 1, y: 0 },
  { c: "#8B5CF6", x: 0, y: 1 },
  { c: "#F59E0B", x: 1, y: 1 },
];

export function SoaSymbol({ size = 40, variant = "os", surface = "#0B0D10", className }) {
  const chico = size < 24;
  const ficha = chico ? 29 : 27;
  const origen = 21;
  const paso = chico ? 29 : 31;           // 21 % → 52 % (separadas) o 21 % → 50 % (pegadas)
  const radio = Math.round(size * 0.27);
  if (variant === "portal") {
    return (
      <span
        aria-hidden="true"
        className={cn("relative inline-block shrink-0 overflow-hidden", className)}
        style={{ width: size, height: size, borderRadius: radio, background: "#FFFFFF", boxShadow: "inset 0 0 0 1px #DADDE3" }}
      >
        <span style={{ position: "absolute", left: "21%", top: "21%", width: "58%", height: "40%", borderRadius: "22%", background: "#22D3EE" }} />
        <span style={{ position: "absolute", left: "21%", top: "65%", width: "27%", height: "14%", borderRadius: "40%", background: "#111318" }} />
      </span>
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn("relative inline-block shrink-0 overflow-hidden", className)}
      style={{ width: size, height: size, borderRadius: radio, background: surface }}
    >
      {FICHAS_OS.map(({ c, x, y }) => (
        <span
          key={c}
          style={{
            position: "absolute",
            left: `${origen + x * paso}%`,
            top: `${origen + y * paso}%`,
            width: `${ficha}%`,
            height: `${ficha}%`,
            borderRadius: "30%",
            background: c,
          }}
        />
      ))}
    </span>
  );
}

/** Lockup: símbolo + «SOA 10 PRO» (Figtree 900, -0.03em). Plegado: solo el símbolo de 40 px. */
export function SoaLogo({ collapsed = false, tone = "claro", className }) {
  const tinta = tone === "oscuro" ? "#FFFFFF" : "#111318";
  const acento = tone === "oscuro" ? "#22D3EE" : "#0E7490";
  const bajada = tone === "oscuro" ? "#A6ABB6" : "#5B5E68";
  return (
    <span className={cn("inline-flex items-center gap-3", className)}>
      <SoaSymbol size={40} surface={tone === "oscuro" ? "#16191F" : "#0B0D10"} />
      {!collapsed && (
        <span className="flex flex-col justify-center" style={{ lineHeight: 0.95, letterSpacing: "-0.03em" }}>
          <span className="text-[20px] font-black" style={{ color: tinta }}>
            SOA <span style={{ color: acento }}>10 PRO</span>
          </span>
          <span className="text-[12px] font-semibold mt-1" style={{ color: bajada, letterSpacing: "0.04em" }}>THE CREW AGENCIA</span>
        </span>
      )}
    </span>
  );
}

export default SoaLogo;
